import PropTypes from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * @deprecated
  * Use dividers prop instead
  * Decide whether or not to include dividers between Column.
  */
  cardDividers: deprecatedProp(PropTypes.bool, 'Use dividers prop instead'),

  /**
  * Decide whether or not to include dividers between each Column.
  */
  dividers: PropTypes.bool,

  /**
  * Specify the gutter width
  * Available options: 'standard', 'tight'
  */
  gutter: PropTypes.oneOf(['standard', 'tight'])
};
var GridContainer = createComponent({
  displayName: 'GridContainer',
  root: 'div',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.grid,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-grid-container']);
      if (props.dividers || props.cardDividers) classNameSet.add('swan-grid-dividers');
      if (props.gutter === 'tight') classNameSet.add('swan-grid-container-tight');
      return classNameSet;
    }
  }
});
GridContainer.defaultProps = {
  dividers: false,
  gutter: 'standard'
};
export { GridContainer };